import useActions from 'hooks/useActions';
import { useReducer } from 'react';
import MarkdownHint from 'components/StaticElements/MarkdownHint';
import MarkdownEditor from '@uiw/react-markdown-editor';

const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {

    };
}

function reducer(state, action) {
    switch (action.type) {
        case 'name':
            return { ...state, name: action.data };
        case 'description':
            return { ...state, description: action.data };
        case 'is_active':
            return { ...state, is_active: action.data };
        default:
            return state;
    }
}

const VHSProgramNew = connect(mapStateToProps)(function (props) {
    const initialState = {
        name: '',
        description: '',
        is_active: false,
    };
    const { VHS_POST_PROGRAM_REQUEST } = useActions();

    const [updatedProgram, dispatch] = useReducer(reducer, initialState);

    function onFieldChange(event) {
        dispatch({
            type: event.target.name,
            data: event.target.value,
        });
    }

    function handleMarkdownChange(name, value){
        dispatch({
            type: name,
            data: value,
        });
    }

    function onConfirmChanges(event) {
        event.preventDefault();
        try {
            const program = {
                ...updatedProgram
            };
            VHS_POST_PROGRAM_REQUEST(program);
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <section>
            <form onSubmit={onConfirmChanges}>
                <table className='edit-table'>
                    <tbody>
                        <tr>
                            <td className="font-bold label">Name</td>
                            <td>
                                <input
                                    className='w-full'
                                    name="name"
                                    value={updatedProgram.name}
                                    onChange={onFieldChange}
                                    required
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className="font-bold label">
                                Description
                            </td>
                            <td>
                                <MarkdownEditor
                                    name="description"
                                    value={updatedProgram.description}
                                    onChange={(value) => handleMarkdownChange('description',value)}
                                    toolbars={['bold','italic','underline','header','olist','ulist']}
                                    height={500}
                                />
                                <MarkdownHint />
                            </td>
                        </tr>
                        <tr>
                            <td className="font-bold label">Visibility</td>
                            <td>
                                <select
                                    name="is_active"
                                    value={updatedProgram.is_active}
                                    onChange={onFieldChange}
                                >
                                    <option value={true}>Published</option>
                                    <option value={false}>Unpublished</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <button type="submit" className="mt-4 button save-changes-button">
                                    Add Program
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </section>
    );
});

export default VHSProgramNew;
